export const CREATE_RELATION = 'CREATE_RELATION';
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS';
export const FETCH_ALL_RELATIONS = 'FETCH_ALL_RELATIONS';
export const FETCH_RELATION = 'FETCH_RELATION';
export const DELETE_RELATION = 'DELETE_RELATION';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const CREATE_USER = 'CREATE_USER';
